import styled from 'styled-components';
import Slider from 'react-slick';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const BreakLine = styled.div<any>`
  width: 100%;
  border-bottom: solid 1px #dadada;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CustomSlider = styled(Slider as any)`
  position: relative;
  width: 100%;
  height: 100%;
  margin-bottom: 30px;
`;
